module.exports = __webpack_public_path__ + "img/icon_face_to_face.92294daf.png";